"use client";

import { useEffect, useRef } from "react";
import { useUser } from "@/context/AuthContext";
import { useLocale } from "next-intl";
import { identifyPostHogUser, resetPostHogUser, setPostHogPersonProperties } from "@/lib/posthogIdentify";
import { hasAnalyticsConsent } from "@/lib/consentCookie";

/**
 * Keeps PostHog identify + locale person properties in sync with auth and i18n.
 * Mount inside AuthContextProvider + I18nProvider (or with useLocale available).
 */
export default function PostHogIdentifyTracker(): null {
  const user = useUser();
  const locale = useLocale();
  const lastUidRef = useRef<string | null>(null);
  useEffect(() => {
    const sync = () => {
      if (!hasAnalyticsConsent()) return;
      if (user?.uid) {
        if (lastUidRef.current !== user.uid) {
          identifyPostHogUser(user.uid, {
            language: locale
          });
          lastUidRef.current = user.uid;
        } else {
          setPostHogPersonProperties({
            language: locale
          });
        }
      } else if (lastUidRef.current) {
        resetPostHogUser();
        lastUidRef.current = null;
      }
    };
    sync();
    document.addEventListener("braiv:consent", sync);
    return () => document.removeEventListener("braiv:consent", sync);
  }, [user?.uid, locale]);
  return null;
}